import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { viewCommentChild } = apiStoreLenses

export default (state, { recordId }) => viewCommentChild(recordId, state)
